// mCustomScrollbar
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.css';


// WEBPACK FOOTER //
// ./src/common/assets/vendors/index.js